import { render } from "./newTickets.vue?vue&type=template&id=17eccc76&scoped=true"
import script from "./newTickets.vue?vue&type=script&lang=js"
export * from "./newTickets.vue?vue&type=script&lang=js"

import "./newTickets.vue?vue&type=style&index=0&id=17eccc76&scoped=true&lang=scss"
import "./newTickets.vue?vue&type=style&index=1&id=17eccc76&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17eccc76"]])

export default __exports__